
















import DownloadDia from '@/components/DownLoadDia.vue'; // 下载弹框组件
import Vue from 'vue';
import * as api from '@/api';
import CardProduct from '@/components/CardProduct.vue';
import CardContainer from '@/components/CardContainer.vue';
import { getFileTypes } from '@/api/File';

interface ProductFilterData {
    brands: api.FilterBrand[];
    categories: api.FilterCategory[];
    fileTypes: api.FilterFileType[];
    advanced: {
        keyword: string;
        rangeInput?: {
            minValue: number;
            maxValue: number;
            isAsc: boolean;
        };
        listSelectValue?: string;
    }[];
}
interface RelatedProductInfo {
    productId: string;
    name: string;
}

export default Vue.extend({
    name: 'ProductList',
    components: {
        DownloadDia,
        CardProduct,
        CardContainer,
    },
    data() {
        return {
            brandCount: 0,
            productCount: 0,
            productCards: [] as api.ProductCard[],
            sortField: 'collectedCount DESC, id DESC',
            fileTypes: [],
            dialogVisible: {
                show: false,
            },
        };
    },
    computed: {
        relatedProductInfo(): RelatedProductInfo {
            return this.$store.state.relatedProductInfo;
        },
    },
    async created() {
        console.log(this.relatedProductInfo);
        await this.fetchData();
    },
    methods: {
        async fetchData() {
            const cntRes = await api.getProductListCount({
                getCorrelationOfPVId: this.relatedProductInfo.productId,
            });
            if (!api.error(cntRes)) {
                this.brandCount = cntRes.data.brandCount;
                this.productCount = cntRes.data.productCount;
            }
            const res = await api.getProductList({
                getCorrelationOfPVId: this.relatedProductInfo.productId,
            });
            if (!api.error(res)) {
                this.productCards = res.data.items;
            }
        },
        async downloadFile(item) {
            const fileTypes = await getFileTypes({ id: item.id, pvId: item.pvId });
            if (!api.error(fileTypes)) {
                fileTypes.data.length === 0 && this.$message({ type: 'info', message: '暂无模型文件可供下载' });
                fileTypes.data.length > 0 && (this.fileTypes = fileTypes.data) && (this.dialogVisible.show = true);
            }
        },
        async loadMore() {
            if (this.productCards.length > 30) return;
            const res = await api.getProductList({
                getCorrelationOfPVId: this.relatedProductInfo.productId,
                skipCount: this.productCards.length,
            });
            if (!api.error(res)) {
                this.productCards = [...this.productCards, ...res.data.items];
            }
        },
    },
});
